// extracted by mini-css-extract-plugin
module.exports = {"TabTitle":"TabTitle_TabTitle__3MPk_","ActiveTabTitle":"TabTitle_ActiveTabTitle__3Ek6v"};